export default function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
    n10 = t0 && s[0].slice(-1);
  if (ord) return (n10 == 6 || n10 == 9
    || t0 && n10 == 0 && n != 0) ? 'many' : 'other';
  return (n == 1) ? 'one' : 'other';
}
